module.exports = __webpack_public_path__ + "static/media/axegpro-logo.c2c542e5.png";